define('controllers/pages',[
    'helpers/application',
    'controllers/base/controller'
], function(applicationHelper, Controller) {
    'use strict';

    var PagesController = Controller.extend({

        home: function() {
            applicationHelper.redirectTo('dashboard#show',{}, { forceStartup: true });
        }

    });

    return PagesController;
});

